import { AlertTriangle, CheckCircle, X } from 'lucide-react';
import useToastStore from '../../store/toastStore';

export default function UndoToast() {
  const { visible, message, onUndo, variant, hide } = useToastStore();

  if (!visible) return null;

  const isError = variant === 'error';
  const Icon = isError ? AlertTriangle : CheckCircle;

  const handleUndo = () => {
    if (onUndo) onUndo();
    hide();
  };

  return (
    <div
      className="absolute left-1/2 -translate-x-1/2 bottom-0 translate-y-full mt-2 z-[200]"
      role={isError ? 'alert' : 'status'}
      aria-live={isError ? 'assertive' : 'polite'}
    >
      <div className={`flex items-center gap-3 px-4 py-2.5 rounded-lg shadow-xl text-white text-sm font-medium min-w-[260px] max-w-sm ${isError ? 'bg-[#e2445c]' : 'bg-[#00c875]'}`}>
        <Icon className="w-4 h-4 shrink-0" />
        <span className="flex-1 leading-snug">{message}</span>
        {onUndo && (
          <button
            onClick={handleUndo}
            className="shrink-0 border border-white/40 rounded px-2.5 py-0.5 text-xs font-semibold hover:bg-white/20 transition-colors"
          >
            Desfazer
          </button>
        )}
        <button
          onClick={hide}
          className="shrink-0 p-0.5 hover:bg-white/20 rounded transition-colors"
          aria-label="Fechar"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
